import styled from "@emotion/styled";

export const Root = styled.div<{ alignRight?: boolean }>(
    props =>
        props.alignRight && {
            float: "right",
            marginTop: 5,
        }
);
